var React = require('react');

function IconMap (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M12 18l-4.57-6.45A6.1 6.1 0 0112 1.5a6.06 6.06 0 016 6.1c0 1.4-.48 2.75-1.35 3.85L12 18zm0-15a4.55 4.55 0 00-4.5 4.6c0 1.1.4 2.16 1.12 3L12 15.39l3.47-4.89a4.68 4.68 0 00-.27-6.13C14.36 3.5 13.2 3 12 3z","key":0}),React.createElement("path",{"d":"M12 8.25a1.5 1.5 0 100-3 1.5 1.5 0 000 3zM21 9h-1.5v1.5H21V21H3V10.5h1.5V9H3a1.5 1.5 0 00-1.5 1.5V21A1.5 1.5 0 003 22.5h18a1.5 1.5 0 001.5-1.5V10.5A1.5 1.5 0 0021 9z","key":1})]);
}

IconMap.defaultProps = {"fill":"currentColor","aria-hidden":"true","focusable":"false","viewBox":"0 0 24 24"};

module.exports = IconMap;

IconMap.default = IconMap;
